import React, { useState, useEffect } from 'react';
import './BlogPage.css?inline';
import Navbar from '../MainComponents/Navbar';
import Footer from '../MainComponents/Footer';
import { db, auth } from '../../Firebaseconfig';
import {
  collection,
  addDoc,
  deleteDoc,
  doc,
  onSnapshot,
  serverTimestamp,
  query,
  orderBy,
  getDoc
} from 'firebase/firestore';
import { onAuthStateChanged } from 'firebase/auth';
import { useTranslation } from 'react-i18next';




const INITIAL_POSTS = [
  {
    id: 1,
    title: "The Future of Urban Delivery: AI, Drones, and Efficiency",
    category: "Tech & Innovation",
    excerpt: "Discover how AI-powered drone dispatch logistics networks are changing food and goods delivery systems in major metropolises.",
    content: "Drone logistics systems are rapidly transforming urban landscapes. By integrating deep-learning route planning with autonomous hardware, delivery networks can bypass metropolitan traffic entirely, ensuring your order arriving under optimal freshness metrics.",
    date: "Jun 3, 2026",
    image: "https://images.unsplash.com/photo-1508614589041-895b88991e3e?w=800&auto=format&fit=crop&q=60",
    readTime: "5 min read",
    author: "CraveDash Editor",
    isFeatured: true
  },
  {
    id: 2,
    title: "New Michelin-Starred Partners Join the Platform",
    category: "Partner Stories",
    excerpt: "Fine dining meets convenience as top culinary masters partner to bring elite gastronomic menus directly to foodies.",
    content: "We are thrilled to unveil an exclusive collaboration with award-winning kitchens globally. Patrons can now secure premium, bespoke multi-course menus directly tailored for dynamic domestic serving frameworks.",
    date: "Jun 2, 2026",
    image: "https://images.unsplash.com/photo-1544025162-d76694265947?w=800&auto=format&fit=crop&q=60",
    readTime: "4 min read",
    author: "CraveDash Editor",
    isFeatured: true
  },
  {
    id: 3,
    title: "Eco-Friendly Packaging: Our Green Initiative",
    category: "Sustainability",
    excerpt: "Moving toward 100% biodegradable custom containers to reduce urban footprint carbon impact drastically.",
    content: "Our global mandate targets zero waste via specialized plant-cellulose packaging frameworks. This completely mitigates toxic plastic tracking while retaining optimal dynamic temperatures for thermal culinary food preservation.",
    date: "Jun 1, 2026",
    image: "https://images.unsplash.com/photo-1530587191325-3db32d826c18?w=800&auto=format&fit=crop&q=60",
    readTime: "3 min read",
    author: "CraveDash Editor",
    isFeatured: true
  },
  {
    id: 4,
    title: "Why Smoke-Infused Cocktails are Dominating the Nightlife Scene",
    category: "Food Trends",
    excerpt: "Discover how mixologists are using local woods and aromatic herbs to create sensory experiences that go...",
    content: "The science of molecular mixology centers closely on olfactory response captures. Using cold-smoke variance infusions from oak barrels and fresh rosemary leaves, contemporary lounges elevate standard drink menus into total sensory performance art.",
    date: "May 28, 2026",
    image: "https://images.unsplash.com/photo-1514362545857-3bc16c4c7d1b?w=800&auto=format&fit=crop&q=60",
    readTime: "4 min read",
    author: "Arber",
    isFeatured: false
  },
  {
    id: 5,
    title: "Ghost Kitchens: Scaling Your Restaurant Without the Real Estate",
    category: "Partner Stories",
    excerpt: "How small local eateries are using the CraveDash logistics network to expand their reach to entire cities overnight...",
    content: "Traditional structural real estate constraints often limit operational margins for growing dining spots. Digital-first decentralized scaling setups unlock vast delivery coverage perimeters without micro-managing commercial physical storefront overhead.",
    date: "May 15, 2026",
    image: "https://images.unsplash.com/photo-1556910103-1c02745aae4d?w=800&auto=format&fit=crop&q=60",
    readTime: "6 min read",
    author: "Guest Dev",
    isFeatured: false
  },
  {
    id: 6,
    title: "Mindful Eating: The Art of Slowing Down in a Fast-Paced World",
    category: "Lifestyle",
    excerpt: "Why the next big culinary trend isn't about what you eat, but how you experience every single bite of your meal...",
    content: "Slowing operational down allows clean neuro-digestive tracking, tasting deeper flavor complexities, and reconnecting comfortably over shared, unhurried traditional dining ritual spaces.",
    date: "May 10, 2026",
    image: "https://images.unsplash.com/photo-1506126613408-eca07ce68773?w=800&auto=format&fit=crop&q=60",
    readTime: "3 min read",
    author: "Arber",
    isFeatured: false
  }
];

const DONT_MISS_ITEMS = [
  {
    id: "dm1",
    title: "The Best Artisan Coffee Roasters in Seattle for 2024",
    category: "Lifestyle",
    excerpt: "A complete guide to small-batch single-origin coffees.",
    content: "Seattle's micro-roasting underground scene is leaning heavily into lighter fermentation processing, exposing bright fruit profiles.",
    date: "2 hours ago",
    readTime: "3 min read",
    author: "CraveDash Editor",
    image: "https://images.unsplash.com/photo-1514432324607-a09d9b4aefdd?w=150&auto=format&fit=crop&q=60"
  },
  {
    id: "dm2",
    title: "How Top Chefs are Battling Rising Food Costs",
    category: "Business",
    excerpt: "Smart menu engineering strategies protecting gourmet models.",
    content: "Top-tier culinary groups manage fluctuating ingredient inflation index models through hyper-local seasonal rotation swaps.",
    date: "5 hours ago",
    readTime: "5 min read",
    author: "CraveDash Editor",
    image: "https://images.unsplash.com/photo-1577219491135-ce391730fb2c?w=150&auto=format&fit=crop&q=60"
  },
  {
    id: "dm3",
    title: "Why Bluefin Tuna Sustainability is Making a Comeback",
    category: "Sustainability",
    excerpt: "Strict catch quotas show massive oceanic recovery progress.",
    content: "Thanks to multi-national collaborative deep-sea patrol agreements, wild tuna populations have marked record-breaking health indexing.",
    date: "Yesterday",
    readTime: "4 min read",
    author: "CraveDash Editor",
    image: "https://images.unsplash.com/photo-1579871494447-9811cf80d66c?w=150&auto=format&fit=crop&q=60"
  }
];

const BLOGPOSTS_COLLECTION = 'blogPosts';

export default function BlogPage() {
  const { t } = useTranslation();
  const [posts, setPosts] = useState(INITIAL_POSTS);     // static hero posts only
  const [firebasePosts, setFirebasePosts] = useState([]); // live posts from Firestore
  const [fbLoading, setFbLoading] = useState(true);
  const [saveError, setSaveError] = useState(null);
  // Real auth state
  const [authUser, setAuthUser] = useState(null);       // Firebase Auth user
  const [userRole, setUserRole] = useState(null);       // Firestore role field
  const [authLoading, setAuthLoading] = useState(true); // waiting for auth check
  const isAdmin = authUser && userRole === 'admin';
  const [activeCategory, setActiveCategory] = useState("All Posts");
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedPost, setSelectedPost] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [visibleCount, setVisibleCount] = useState(3);
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => { setIsLoaded(true); }, []);

  // Watch Firebase Auth + fetch user role from Firestore
  useEffect(() => {
    const unsubAuth = onAuthStateChanged(auth, async (user) => {
      setAuthUser(user);
      if (user) {
        try {
          const snap = await getDoc(doc(db, 'users', user.uid));
          setUserRole(snap.exists() ? snap.data().role : null);
        } catch {
          setUserRole(null);
        }
      } else {
        setUserRole(null);
      }
      setAuthLoading(false);
    });
    return () => unsubAuth();
  }, []);

  // Load posts from Firestore into firebasePosts (Latest Stories feed)
  useEffect(() => {
    const q = query(collection(db, BLOGPOSTS_COLLECTION), orderBy('createdAt', 'desc'));
    const unsubscribe = onSnapshot(q, (snapshot) => {
      const fbPosts = snapshot.docs.map(docSnap => ({
        ...docSnap.data(),
        id: docSnap.id,
        firestoreId: docSnap.id
      }));
      setFirebasePosts(fbPosts);
      setFbLoading(false);
    }, (err) => {
      console.error('Firestore read error:', err);
      setFbLoading(false);
    });
    return () => unsubscribe();
  }, []);

  /* Scroll-reveal observer */
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries, obs) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('revealed');
            obs.unobserve(entry.target);
          }
        });
      },
      { root: null, rootMargin: '0px 0px -8% 0px', threshold: 0.05 }
    );
    const els = document.querySelectorAll(
      '.reveal, .reveal-left, .reveal-right, .reveal-scale, .reveal-stagger'
    );
    els.forEach((el) => observer.observe(el));
    return () => els.forEach((el) => observer.unobserve(el));
  }, [fbLoading, firebasePosts]);

  // Form Processing States
  const [formData, setFormData] = useState({
    title: '',
    category: 'Food Trends',
    excerpt: '',
    content: '',
    image: ''
  });

  // Dynamic Post Submission Handler — saves to Firestore
  const handleFormSubmit = async (e) => {
    e.preventDefault();
    setSaveError(null);
    
    // Fallback decorative image if user leaves link input blank
    const fallbackImage = "https://images.unsplash.com/photo-1498837167922-ddd27525d352?w=800&auto=format&fit=crop&q=60";

    const newPost = {
      title: formData.title,
      category: formData.category,
      excerpt: formData.excerpt,
      content: formData.content,
      date: new Date().toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }),
      image: formData.image.trim() !== '' ? formData.image : fallbackImage,
      readTime: `${Math.max(1, Math.ceil(formData.content.split(' ').length / 150))} min read`,
      author: authUser?.displayName || authUser?.email || 'Admin',
      isFeatured: false,
      createdAt: serverTimestamp()
    };

    try {
      // Save to Firestore — the onSnapshot listener will update state automatically
      await addDoc(collection(db, BLOGPOSTS_COLLECTION), newPost);
    } catch (err) {
      console.error('Error saving post:', err);
      setSaveError(t('blog.failedPublish'));
      return;
    }

    // Clear out form & hide panel safely
    setFormData({ title: '', category: 'Food Trends', excerpt: '', content: '', image: '' });
    setShowForm(false);
  };

  const handleDeletePost = async (post, e) => {
    e.stopPropagation(); // Stops lightbox opening accidentally on button press
    if (window.confirm(`${t('blog.confirmDelete')} "${post.title}"?`)) {
      // If the post came from Firestore it will have a firestoreId
      if (post.firestoreId) {
        try {
          await deleteDoc(doc(db, BLOGPOSTS_COLLECTION, post.firestoreId));
          // onSnapshot will handle removing it from state
        } catch (err) {
          console.error('Error deleting post:', err);
        }
      } else {
        // Static initial post — just remove from local state
        setPosts(posts.filter(p => p.id !== post.id));
      }
    }
  };

  const categories = ["All Posts", "Food Trends", "Partner Stories", "Tech & Innovation", "Lifestyle", "Business"];
  
  const featuredPosts = posts.filter(p => p.isFeatured);

  // Latest Stories = Firebase posts only, filtered by category + search
  const standardPosts = firebasePosts.filter(p => {
    const matchesCategory = activeCategory === "All Posts" || p.category === activeCategory;
    const matchesSearch = p.title.toLowerCase().includes(searchQuery.toLowerCase());
    return matchesCategory && matchesSearch;
  });
  
  const displayedPosts = standardPosts.slice(0, visibleCount);

  return (
    <div className="crave-magazine-theme">

      <Navbar />
      

      {/* --- TRENDING BAR --- */}
      <div className={`trending-ticker ${isLoaded ? 'animate-in' : ''}`}>
        <span className="ticker-badge">{t('blog.trending')}</span>
        <p className="ticker-text">{t('blog.trendingText')}</p>
      </div>

      {/* --- NAVIGATION --- */}
      <nav className="mag-nav">
        <div className="mag-logo">N'<span>Shpejt</span></div>
        <div className="mag-nav-center-links">
          <span className="nav-link active">{t('blog.magazine')}</span>
          <span className="nav-link">{t('blog.restaurants')}</span>
          <span className="nav-link">{t('blog.offers')}</span>
        </div>
        <div className="mag-nav-right-actions">
          <div className="search-pill-container">
            <span>🔍</span>
            <input 
              type="text" 
              placeholder={t('blog.searchStories')} 
              className="search-stories-input"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)} 
            />
          </div>
          {!authLoading && isAdmin && (
            <button className="theme-write-btn" onClick={() => setShowForm(!showForm)}>
              {showForm ? t('blog.cancel') : t('blog.createPost')}
            </button>
          )}
          <div className="user-avatar-circle"></div>
        </div>
      </nav>

      {/* --- FEATURED HERO BLOCK --- */}
      {activeCategory === "All Posts" && !searchQuery && featuredPosts.length >= 3 && (
        <section className={`hero-feature-layout ${isLoaded ? 'animate-in' : ''}`}>
          <div className="hero-main-card" onClick={() => setSelectedPost(featuredPosts[0])}>
            <img src={featuredPosts[0].image} alt="" />
            <div className="hero-card-overlay">
              <span className="mag-badge accent-orange">{featuredPosts[0].category}</span>
              <h2>{featuredPosts[0].title}</h2>
              <p className="hero-card-meta">{featuredPosts[0].readTime} • {featuredPosts[0].date}</p>
            </div>
          </div>
          <div className="hero-side-column">
            <div className="hero-sub-card" onClick={() => setSelectedPost(featuredPosts[1])}>
              <img src={featuredPosts[1].image} alt="" />
              <div className="hero-card-overlay">
                <span className="mag-badge accent-gold">{featuredPosts[1].category}</span>
                <h3>{featuredPosts[1].title}</h3>
              </div>
            </div>
            <div className="hero-sub-card" onClick={() => setSelectedPost(featuredPosts[2])}>
              <img src={featuredPosts[2].image} alt="" />
              <div className="hero-card-overlay">
                <span className="mag-badge accent-green">{featuredPosts[2].category}</span>
                <h3>{featuredPosts[2].title}</h3>
              </div>
            </div>
          </div>
        </section>
      )}

      {/* --- NEW DYNAMIC POST CREATOR FORM OVERLAY --- */}
      {showForm && isAdmin && (
        <div className="mag-modal-wrapper" onClick={() => setShowForm(false)}>
          <div className="mag-form-card" onClick={(e) => e.stopPropagation()}>
            <div className="form-modal-header">
              <h3>{t('blog.createNewStory')}</h3>
              <button className="close-form-btn" onClick={() => setShowForm(false)}>✕</button>
            </div>
            <form onSubmit={handleFormSubmit}>
              <label>{t('blog.articleTitle')}</label>
              <input 
                type="text" 
                placeholder={t('blog.articleTitlePlaceholder')} 
                required 
                value={formData.title} 
                onChange={(e) => setFormData({...formData, title: e.target.value})} 
              />

              <div className="form-split">
                <div>
                  <label>{t('blog.categoryTag')}</label>
                  <select value={formData.category} onChange={(e) => setFormData({...formData, category: e.target.value})}>
                    {categories.slice(1).map(c => <option key={c} value={c}>{c}</option>)}
                  </select>
                </div>
                <div>
                  <label>{t('blog.coverImageUrl')}</label>
                  <input 
                    type="url" 
                    placeholder={t('blog.coverImagePlaceholder')} 
                    value={formData.image} 
                    onChange={(e) => setFormData({...formData, image: e.target.value})} 
                  />
                </div>
              </div>

              <label>{t('blog.shortSnippet')}</label>
              <input 
                type="text" 
                placeholder={t('blog.shortSnippetPlaceholder')} 
                required 
                value={formData.excerpt} 
                onChange={(e) => setFormData({...formData, excerpt: e.target.value})} 
              />

              <label>{t('blog.fullArticleBody')}</label>
              <textarea 
                placeholder={t('blog.fullArticlePlaceholder')} 
                rows="6" 
                required 
                value={formData.content} 
                onChange={(e) => setFormData({...formData, content: e.target.value})}
              ></textarea>

              {saveError && (
                <p style={{ color: '#ff4d4d', fontSize: '0.85rem', margin: '0 0 8px' }}>⚠️ {saveError}</p>
              )}
              <button type="submit" className="publish-submit-btn">{t('blog.publishToFirebase')}</button>
            </form>
          </div>
        </div>
      )}

      {/* --- CATEGORIES STRIP --- */}
      <div className="categories-filter-strip reveal">
        <span className="filter-lbl">{t('blog.categories')}</span>
        <div className="filter-buttons">
          {categories.map(cat => (
            <button key={cat} className={activeCategory === cat ? "active" : ""} onClick={() => setActiveCategory(cat)}>
              {cat}
            </button>
          ))}
        </div>
      </div>

      {/* --- MAIN STRUCTURE --- */}
      <div className="editorial-main-framework">
        
        {/* Feed Column */}
        <div className="stories-left-feed reveal-left">
          <h2 className="section-title-divider">{t('blog.latestStories')}</h2>
          
          {fbLoading && (
            <div style={{ padding: '12px 0', color: '#999', fontSize: '0.9rem' }}>{t('blog.loadingPosts')}</div>
          )}
          
          {displayedPosts.length > 0 ? (
            displayedPosts.map(post => (
              <article key={post.id} className="mag-horizontal-card" onClick={() => setSelectedPost(post)}>
                <div className="card-thumb-frame">
                  <img src={post.image} alt="" />
                </div>
                <div className="card-text-details">
                  <span className="meta-category-tag">{post.category}</span>
                  <h3 className="card-heading-title">{post.title}</h3>
                  <p className="card-paragraph-snippet">{post.excerpt}</p>
                  <div className="card-footer-action-row">
                    <span className="card-meta-inline">📖 {post.readTime} • {t('blog.by')} {post.author} • {post.date}</span>
                    <div className="action-buttons-holder">
                      <span className="inline-read-btn">{t('blog.readMore')}</span>
                      {isAdmin && (
                        <button className="mag-delete-action" onClick={(e) => handleDeletePost(post, e)} title="Delete Post">
                          {t('blog.delete')}
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              </article>
            ))
          ) : (
            <div className="empty-feed-state">{t('blog.emptyFeed')}</div>
          )}

          {standardPosts.length > visibleCount && (
            <div className="load-more-container">
              <button className="load-more-btn" onClick={() => setVisibleCount(prev => prev + 3)}>
                {t('blog.loadMore')}
              </button>
            </div>
          )}
        </div>

        {/* Sidebar Column */}
        <aside className="editorial-right-sidebar reveal-right">
          <div className="sidebar-widget-box reveal-scale">
            <h4>{t('blog.stayConnected')}</h4>
            <div className="social-metrics-grid reveal-stagger">
              <div className="social-pill fb"><div className="pill-l">{t('blog.like')}</div><strong>12.4K</strong></div>
              <div className="social-pill ig"><div className="pill-l">{t('blog.follow')}</div><strong>58.2K</strong></div>
              <div className="social-pill tw"><div className="pill-l">{t('blog.twitterFollow')}</div><strong>10.1K</strong></div>
              <div className="social-pill yt"><div className="pill-l">{t('blog.sub')}</div><strong>1.2M</strong></div>
            </div>
          </div>

          <div className="sidebar-widget-box reveal-scale">
            <h4 className="dont-miss-header">{t('blog.dontMiss')}</h4>
            <div className="mini-stories-stack reveal-stagger">
              {DONT_MISS_ITEMS.map(item => (
                <div key={item.id} className="mini-item-card" onClick={() => setSelectedPost(item)}>
                  <img src={item.image} alt="" className="mini-thumb" />
                  <div className="mini-content">
                    <h5>{item.title}</h5>
                    <small>{item.date}</small>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </aside>
      </div>

      {/* --- FOOTER --- */}
      <footer className="mag-footer-container reveal">
        <div className="footer-columns-grid">
          <div className="footer-brand-col">
            <h3>CraveDash</h3>
            <p>Delivering the finest culinary experiences and industry insights straight to your doorstep.</p>
          </div>
          <div className="footer-links-col">
            <h4>COMPANY</h4>
            <span>Become a Partner</span>
            <span>About CraveDash</span>
          </div>
          <div className="footer-links-col">
            <h4>LEGAL</h4>
            <span>Terms of Service</span>
            <span>Privacy Policy</span>
          </div>
          <div className="footer-newsletter-col">
            <h4>NEWSLETTER</h4>
            <div className="newsletter-form-group">
              <input type="email" placeholder="Email address" disabled />
              <button type="button">JOIN</button>
            </div>
          </div>
        </div>
      </footer>

      {/* Lightbox Reader Overlay */}
      {selectedPost && (
        <div className="modal-overlay" onClick={() => setSelectedPost(null)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <button onClick={() => setSelectedPost(null)} className="modal-close">&times;</button>
            <img src={selectedPost.image} alt="" className="modal-image" />
            <div className="modal-body">
              <span className="modal-category">{selectedPost.category}</span>
              <h2 className="modal-title">{selectedPost.title}</h2>
              <p className="modal-meta">{t('blog.by')} {selectedPost.author || t('blog.staff')} • {selectedPost.date}</p>
              <p className="modal-text">{selectedPost.content}</p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}